import { IonItem, IonLabel } from '@ionic/react';
import React from 'react';
import Typography from '../../common/Typography';

interface ListItemProps {
  id?: string;
  title: string | React.ReactNode;
  value?: string;
  onClick?: () => void;
}

const ListItem: React.FC<ListItemProps> = ({ title, value, id, onClick }) => {
  return (
    <IonItem button detail id={id} onClick={onClick}>
      <IonLabel>
        <Typography as="h2" variant="body2" fontWeight="bold !important">
          {title}
        </Typography>
        <Typography as="p" variant="body2" color="medium">
          {value}
        </Typography>
      </IonLabel>
    </IonItem>
  );
};

export default ListItem;
